import React, { useEffect } from "react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Team } from "../components/sections/Team";
import { Gallery } from "../components/sections/Gallery";
import { Services } from "../components/sections/Services";
import { Contact } from "../components/sections/Contact";

export default function Home() {
    useEffect(() => {
        if (window.location.hash) {
            const el = document.querySelector(window.location.hash);
            if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 120);
        }
    }, []);

    return (
        <div className="min-h-screen bg-brand-cream" data-testid="home-page">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Team />
                <Gallery />
                <Services />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
